@if (videoId()) {
<ds-video-player [videoId]="videoId()"
    [controller]="controller()"
    [closedCaptions]="closedCaptions()"
    [retryLimit]="retryLimit()"
    [fullscreen]="true"
    [overlay]="true"
    animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
}
@if (!videoId()) {
<ds-video-error animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
}
